<template>
  <div>
    <layout-loading v-if="isSubmit" />
    <BDataTable
      ref="refTable"
      :fetch-list="fetchList"
      :table-columns="tableColumns"
      @onGroupDelete="groupDelete"
    >
      <template #leftHeader>
        <b-button
          variant="outline-primary"
          :disabled="isSubmit"
          @click="exportExcelAndDownload"
        >
          {{ $t("general.exportExcel") }}
        </b-button>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="{ item }">
        <edit-row @click.native="toEditPage(item._id)" />
        <delete-row @click.native="deleteItem(item._id)" />
      </template>
    </BDataTable>
  </div>
</template>

<script>
import {
  BButton,
} from 'bootstrap-vue'
import BDataTable from '@/components/BDataTable/index.vue'
import DeleteRow from '@/components/BDataTable/Actions/DeleteRow.vue'
import EditRow from '@/components/BDataTable/Actions/EditRow.vue'
import LayoutLoading from '@/components/LayoutLoading.vue'
import useSubscriptionsList from './useSubscriptionsList'

export default {
  name: 'SubscriptionList',
  components: {
    BButton,
    BDataTable,
    DeleteRow,
    EditRow,
    LayoutLoading,
  },
  setup() {
    const {
      deleteItem,
      exportExcel,
      fetchList,
      groupDelete,
      isSubmit,
      refTable,
      tableColumns,
      toEditPage,
    } = useSubscriptionsList()

    return {
      deleteItem,
      exportExcel,
      fetchList,
      groupDelete,
      isSubmit,
      refTable,
      tableColumns,
      toEditPage,
    }
  },
  methods: {
    exportExcelAndDownload() {
      this.exportExcel().then(response => {
        const url = URL.createObjectURL(new Blob([response.data], {
          type: 'application/vnd.ms-excel',
        }))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'suggestion')
        document.body.appendChild(link)
        link.click()
      })
    },
  },
}
</script>
